import React from "react";
import "./navbar.css";
import Images from "../../data/Images";

const Navbar = () => {
  return (
    <div className="navbar">
      <div data-aos="fade-down" className="navbar-logo">
        <img src={Images.logo} alt="logo" />
      </div>
      <div data-aos="fade-down" className="links">
        <a href="#service" className="link">
          Services
        </a>
        <a href="#projects" className="link">
          Projects
        </a>
        <a href="#about" className="link">
          About
        </a>
        
      </div>
      <div data-aos="fade-down" className="input-bar">
        <a href={require("../../Assets/Resume.pdf")} download="Resume" className='button1'>Resume</a>
      </div>
    </div>
  );
};

export default Navbar;